import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import user from './modules/user';
import tableField from './modules/table-field';
import permission from './modules/permission';
import common from './modules/common';
import sale from './modules/sale';
import b2b from './modules/b2b';
import cost from './modules/cost';
import budget from './modules/budget';
import getters from './getters';
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    common,
    tableField,
    sale,
    b2b,
    cost,
    budget
  },
  getters
});

export default store;
